/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2021 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * Translation file for Spanish(Mexico) language
 *
 * @file es-mx.js
 * @author Manimaran.S
 */

const esmx = {
  'popularChannelSlider.allChannels': 'Todos los canales',
  'popularChannelSlider.recommended': 'Texto recomendado',
  'hero.myetextbook.link': 'biblioteca',
  'hero.myetextbook.text': '¿No es el título correcto? Abra su libro electrónico',
  'hero.etextfeaturestitle': 'Encuentre materiales de estudio en su libro de texto electrónico',
  'hero.etextfeaturesdescription': 'Su libro de texto electrónico viene con materiales de estudio diseñados para ayudarle a tener éxito. Estudie con tarjetas didácticas y más desde su libro de texto electrónico.',
  'aichat.title1': 'Obtenga ayuda potenciada por la IA sobre cualquier tema relacionado con este libro de texto electrónico',
  'aichat.chatDesc1': 'Escriba una pregunta para comenzar',
  'subscriptiontext.isSubscribed': 'Parte de su suscripción',
  'subscriptiontext.nonSubscriber': 'Actualizar para obtener el acceso total',
  'topicConatiner.otherHeader': 'Videos y prácticas relacionadas',
  'topicConatiner.exactLiteHeader': 'Conceptos y prácticas relacionadas',
  'moremenu.downloadApp': 'Descargar la aplicación',
  'moremenu.downloadAppAlreadyDownload': '%Click here% para descargar la aplicación en otro dispositivo e iniciar sesión automáticamente o para utilizar su código QR único para iniciar sesión de manera segura en la aplicación que instaló.',
  'moremenu.downloadAppNotDownload': '%Click here% para descargar la aplicación e iniciar sesión de manera segura con su código QR único',
  'channel.noBundletitle': 'Use Preparación de estudio para los cursos relacionados y otros',
  'onboard.studyPlan': 'Se creó el plan de estudio personalizado.',
  'onboard.addCourseAnother': '¿Quiere añadir otro curso?',
  'onboard.purchase': 'Necesito comprar un libro electrónico de Pearson',
  'onboard.addCourseWithoutEtext': 'Añadir curso con Preparación de estudio',
  'onboard.mayBeLater': 'Quizás luego',
  'onboard.aboutCourse': 'Cuéntenos sobre su curso',
  'onboard.close': 'Cerrar',
  'course.addTitle': 'Añadir curso',
  'common.PURCHASE': 'Comprar',
  'common.CLOSE': 'Cerrar',
  'open': 'abrir',
  'continue': 'Continuar',
  'yes': 'Sí',
  'no': 'No',
  'audio': 'Audio',
  'courses.toc.PUBLISH_SUCCESS': '¡Éxito!',
  'courses.toc.PUBLISH_MESSAGE': 'Los estudiantes verán sus cambios la próxima vez que abran el contenido.',
  'errors.GENERIC_TITLE': 'No tiene acceso por ahora',
  'errors.GENERIC_DESC': 'Primero, recargue o despeje su memoria caché. Si eso no funciona, comuníquese con asistencia ',
  'errors.GENERIC_LINK': 'de Pearson.',
  'errors.GENERIC_CODE': 'Código de error: {code}',
  'errors.SUBSCRIPTION_GENERIC_TITLE': 'No se encontró la suscripción.',
  'errors.SUBSCRIPTION_GENERIC_DESC': 'Su cuenta no incluye acceso a este título. Si cree que recibió este mensaje por error, comuníquese con el soporte técnico de Pearson.',
  'errors.SUBSCRIPTION_REGISTRATION_TITLE': 'No se encontró la suscripción.',
  'errors.SUBSCRIPTION_REGISTRATION_DESC': 'Su suscripción no incluye acceso al texto electrónico; sin embargo, puede suscribirse ahora mismo con una tarjeta de crédito.',
  'link.ACCESSIBILITY': 'https://www.pearson.com/us/accessibility.html',
  'link.PRIVACY': 'https://pi.pearsoned.com/v1/piapi/login/static/html/PearsonPrivacyPolicy.html',
  'link.SUPPORT': 'https://support.pearson.com/getsupport/s/?_ga=2.116082310.1845539610.1557867919-NimtqV7BcT00BM9xOXCQUFJYwF3RzEIk',
  'link.TOSURL': 'https://pi.pearsoned.com/v1/piapi/login/static/html/PearsonEULA.html',
  'link.FAQS_NONMOJO': '',
  'link.TERMS_OF_USE_NONMOJO': 'https://www.pearson.com/en-us/legal-information/terms-of-use.html',
  'link.PRIVACY_NOTICE_NONMOJO': 'https://www.pearson.com/en-us/legal-information/privacy-policy.html',
  'link.ACCESSIBILITY_SUPPORT_NONMOJO': '',
  'menu.myAccount': 'Mi cuenta',
  'menu.helpCenter': 'Centro de asistencia',
  'menu.preferencesCenter': 'Centro de preferencias',
  'menu.CONTACT_SUPPORT': 'Comunicarse con soporte',
  'menu.HELP_SUPPORT': 'Ayuda y soporte',
  'menu.FAQS': 'Preguntas frecuentes',
  'menu.CHAT_WITH_SUPPORT': 'Hable con soporte técnico',
  'menu.OTP_CODES': 'Códigos de OTP',
  'menu.LAUNCH_CODE': 'Iniciar el registro de códigos',
  'menu.SEND_CODE': 'Enviar un código nuevo al usuario por correo electrónico',
  'menu.SEND_CODE_PHONE': 'Enviar un código nuevo al usuario por mensaje de texto',
  'menu.LEGAL': 'Legal',
  'menu.PRIVACY_NOTICE': 'Aviso de privacidad',
  'menu.TITLE_INFO': 'Información del título',
  'menu.PEARSON_ACCESSIBILITY': 'Accesibilidad Pearson',
  'menu.DEVICE_WARNING_MESSAGE': 'Registre {deviceLimit} dispositivos. Intercambie 1 al mes.',
  'menu.ACCESSIBILITY': 'Accesibilidad',
  'menu.ACCESSIBILITY_SUPPORT': 'Soporte de accesibilidad',
  'menu.DEVICES': 'Dispositivos recientes',
  'menu.THIS_DEVICE': 'Este dispositivo',
  'menu.GET_THE_APP_DOWNLOAD': 'Descargar la aplicación móvil',
  'menu.MOJO_APP_INFO': 'Visite la tienda de aplicaciones en su teléfono inteligente o tableta para usar Pearson+ sin conexión.',
  'menu.DEVICE_LABEL': 'Dispositivo',
  'menu.DEVICE_DISCONNECT': 'Desconectar',
  'menu.FOXIT': 'Activada por Foxit',
  'menu.TERMS_OF_USE': 'Términos de uso',
  'menu.SIGN_OUT': 'Cerrar sesión',
  'menu.PRINT_PAGE': 'Imprimir página',
  'menu.COPY_RIGHT': 'Copyright © {year} Pearson Education Inc. Todos los derechos reservados.',
  'print.FOOTER_MESSAGE': 'Impreso por {fullName}({email}) el {currentDate}.',
  'print.WATERMARK': 'Copyright © {year} Pearson Education',
  'device.SWAPPED_ALREADY': 'Ya ha hecho un intercambio este mes',
  'device.SWITCH_DEVICE': '¿Cambiar al dispositivo actual?',
  'device.SWITCH_ONCE': 'Dado que solo puede cambiar una vez al mes, no podrá deshacer esta acción.',
  'device.SEAT_TAKEN': 'Ese asiento está ocupado',
  'device.DISCONNECT_DEVICE': 'Solo puede iniciar sesión en 3 dispositivos. Para continuar aquí, desconecte otro dispositivo.',
  'device.ALERT_TEXT': 'Recuerde que solo puede cambiar los dispositivos una vez al mes.',
  'device.DISCONNECT': 'Desconectar',
  'device.CONTINUE': 'Continuar',
  'device.HEADER': '¿Desea cerrar su sesión en el otro navegador?',
  'device.CLOSE': 'Regresar a inicio',
  'device.CODE': 'Para continuar aquí, escriba el código de autenticación que le enviamos a {maskedEmail}. ¿No funciona? Revise su carpeta de correo basura, {email}, o comuníquese con {support}.',
  'device.TIMER': 'Tiene {time} para ingresar su código aquí',
  'device.RESEND': '{resend}',
  'device.FAQ': 'Preguntas frecuentes',
  'device.RESEND_NAME': 'Reenviar',
  'device.NOTE': 'Si usa Pearson+ en 2 lugares con regularidad, como en el trabajo y en casa, asegúrese de cerrar sesión cada vez que termine. También puede usar la aplicación móvil Pearson+ hasta en 2 dispositivos. Para ver más información, consulte nuestra sección de {faq}.',
  'device.NOTE_HEADER': 'Evite esto la próxima vez',
  'device.CONTACT_SUPPORT': 'Servicio de Asistencia al Cliente',
  'device.CONTACT_EMAIL': 'actualice su dirección de correo electrónico',
  'device.INCORRECT': 'Incorrecto: vuelva a verificar el código o solicite que se le reenvíe.',
  'device.MANY_ATTEMPTS': 'Realizó demasiados intentos, pruebe solicitar el reenvío del código',
  'device.EXPIRED': 'El tiempo ha expirado, pruebe solicitar el reenvío del código',
  'device.ACCESS_HEADER': '¡Ha ingresado!',
  'device.ACCESS_DESC': 'Su sesión se ha autenticado. ¿Quiere aprovechar a actualizar su contraseña?',
  'device.ACCESS_CHANGE_PASSWORD': 'Cambiar contraseña',
  'device.ACCESS_RESET_PASSWORD': 'Restablecer contraseña',
  'device.THREATONE_TITLE': '¿Está todo bien?',
  'device.THREATONE_DESC': '"Notamos una actividad sospechosa en su cuenta."',
  'device.THREATONE_DESC_TWO': 'Este es un buen momento para cambiar su contraseña.',
  'device.MAY_BE_LATER': 'Quizás luego',
  'device.OKAY': 'Okay',
  'device.ACCOUNT_LOCK_DESC': 'Por seguridad, cerraremos la sesión. Le enviamos un enlace de restablecimiento de contraseña al correo electrónico asociado con su cuenta.',
  'device.ACCOUNT_LOCK_TITLE': 'Notamos una actividad sospechosa en su cuenta',
  'device.ACCOUNT_LOCK_TIMER': 'La sesión se cerrará en {time}',
  'navigation.PAGE': 'Página',
  'launchcode.CREATEBY': 'Creado por:',
  'launchcode.sentvia': 'Enviado a través de:',
  'launchcode.CODEINLAST': 'Códigos de los últimos siete días:',
  'launchcode.TIMESENT': 'Hora de envío:',
  'launchcode.ACCOUNTEMAIL': 'Correo electrónico de la cuenta:',
  'launchcode.LAUNCHDIALOGTITLE': 'Registro de códigos de OTP',
  'textmessage.TITLE': 'Introducir número de teléfono',
  'textmessage.PHONE_NUMBER': 'Número de teléfono',
  'textmessage.SEND_CODE': 'Enviar código',
  'textmessage.INVALID_NUMBER': 'El número de teléfono móvil no es válido.',
  'textmessage.SUCCESS_MESSAGE': 'Código enviado',
  'remove.title': '¿Desea eliminar el título?',
  'remove.subTitle': 'Puede volver a recuperarlo más adelante, simplemente utilice la búsqueda para volver a agregarlo.',
  'remove.buttonText': 'Eliminar',
  'search.searchPlaceHolderPPlus': 'Buscar por ISBN, título o autor',
  'search.searchPlaceHolderEText': 'Busque en su biblioteca',
  'footer.downloadMobileApp': 'Descargar la aplicación móvil',
  'footer.termsOfUse': 'Términos de uso',
  'footer.privacy': 'Privacidad',
  'footer.cookies': 'Cookies',
  'footer.doNotSellMyPersonalInformation': 'No vendan mi información personal',
  'footer.accessibility': 'Accesibilidad',
  'footer.patentNotice': 'Aviso de patente',
  'footer.copyrights': 'Pearson Todos los derechos reservados.',
  'hero.toc.defaultPlacehoder': '--- seleccione un tema ---',
  'hero.openEtextBookV1': 'Abrir libro electrónico',
  'hero.heroHeading': 'Porque está estudiando <span>{channel_title}</span>',
  'hero.heroHeadingForBundleUser': 'Preparación de estudio',
  'hero.study.help': 'Obtenga ayuda para el estudio',
  'hero.study.jumpBackIn': 'Volver a acceder',
  'hero.study.numOfUsers': 'Actualmente, <b>{num_of_users}</b> estudiantes están usando Canales.',
  'hero.heroChannel.cardsHeading': 'Continúe donde se haya quedado',
  'hero.marketingcard1.copy.title': 'Aprenda con videos',
  'hero.marketingcard1.copy.description': 'Vea videos explicativos breves en los que se analizan temas complicados.',
  'hero.marketingcard2.copy.title': 'Problemas de práctica',
  'hero.marketingcard2.copy.description': 'Prepárese para su examen con miles de preguntas de examen y videos con soluciones.',
  'hero.marketingcard3.copy.title': 'Obtenga ayuda experimentada',
  'hero.marketingcard3.copy.description': 'Publique preguntas y reciba respuestas de expertos en el tema.',
  'hero.popularTopics.heading': 'Otros temas populares de este canal',
  'hero.popularChannels.headingv1': '¿Está haciendo otro curso?',
  'hero.popularChannels.descriptionv2': 'Explore temas populares de ayuda con el estudio.',
  'hero.practice': 'Practicar',
  'hero.herobook.mappedChannelHeading': 'Ayuda con el estudio recomendada en este canal',
  'libraryL2.myBooks': 'Mis libros',
  'libraryL2.archived': 'Archivado',
  'libraryL2.back': 'Atrás',
  'hero.practiceProblem': 'Problema de práctica',
  'nativeAppBanner.drawer.title': 'Abrir en...',
  'nativeAppBanner.drawer.pearsonApp': 'Aplicación Pearson+',
  'nativeAppBanner.banner.title': 'Aplicación Pearson+',
  'nativeAppBanner.banner.description': 'Aprenda en cualquier lugar',
  'hero.promotionalcard.list1': 'Videos breves que explican temas complicados',
  'hero.promotionalcard.list2': 'Miles de preguntas similares a las del examen',
  'hero.promotionalcard.list3': 'Reciba respuestas de expertos en la materia',
  'hero.studyandexamprep': 'Preparación de estudio',
  'hero.heroBook.sectionSubHeadingV1': 'Analice temas difíciles con preguntas de práctica y explicaciones en video adaptadas a su curso.',
  'hero.heroBook.sectionSubHeadingV2': 'Analice temas difíciles con preguntas de práctica y explicaciones conceptuales adaptadas a su curso.',
  'hero.SeeAllStudyOptions': 'Ver todas las opciones de estudio',
  'hero.herobook.mappedChannelHeadingV1': 'Videos recomendados y preguntas de práctica',
  'hero.popularTopics.headingV1': 'Otros temas populares',
  'hero.heroHeadingV1': 'Para <span>{replace_value}</span>',
  'hero.learnmore': 'Leer más',
  'hero.eTextbook': 'Libro electrónico',
  'hero.goToPage.label': 'Ir a la página',
  'subscription.studyTitle': 'Preparación de estudio',
  'print.printAvailTitle': '¿Desea imprimir esta página? Haga lo siguiente.',
  'print.printAvailDesc': 'En su libro electrónico, seleccione el ícono de la cuenta en la parte superior derecha. En opciones, elija "Imprimir página" y luego elija la configuración de impresión deseada.',
  'print.printNotAvailTitle': 'La opción para imprimir este libro de texto electrónico no está habilitada.',
  'print.printNotAvailDesc': 'Para tener acceso conveniente sin internet, descargue su título por medio de la aplicación móvil Pearson+ ¡y disfrute de la flexibilidad de estudiar en cualquier momento y lugar!',
  'hero.header.cta': 'Ir a herramientas de estudio',
  'hero.header.ctav2': 'Abrir Preparación de estudio',
  'hero.marketing.title': 'Encuentre su libro electrónico',
  'hero.marketing.subTitle': 'Elija entre más de 2000 libros electrónicos de texto con audio, tarjetas didácticas, notas y más. A solo $10.99 al mes por un periodo de 4 meses.',
  'hero.popularchannels.desc': 'Obtenga ayuda para el estudio con estos temas principales',
  'hero.removecourse.title': '¿Desea eliminar el curso del panel?',
  'hero.removecourse.description': 'Siempre puede añadir este curso de nuevo al panel. Para ello, haga clic en "Añadir curso".',
  'hero.removecourse.primaryCtaText': 'Eliminar',
  'hero.removecourse.secondaryCtaText': 'CANCELAR',
  'hero.tableOfContents': 'Índice',
  'hero.search': 'Buscar',
  'hero.emptystate.cta': 'Buscar libros de texto electrónicos',
  'hero.watch_it_again': 'Vuelva a verlo',
  'hero.mondly.learnLang.title': 'Aprenda un nuevo idioma gratis',
  'hero.mondly.subTitle': 'Los usuarios de libros de texto electrónicos de Pearson obtienen tres meses gratis de Mondly de Pearson.',
  'hero.mondly.description': 'La mayoría de las aplicaciones para aprender idiomas solo permiten aprender desde el inglés. Sin embargo, lo mejor es aprender desde su lengua materna; por eso, Mondly le permite aprender desde cualquiera de nuestros <strong>41 idiomas</strong>.',
  'hero.mondly.startLearningCTA': 'Comenzar a aprender',
  'hero.mondly.marketing.bestApp': 'Mejor aplicación',
  'hero.mondly.marketing.appStore': 'App Store',
  'hero.mondly.marketing.appYear': 'Aplicación del año',
  'hero.mondly.marketing.fbStart': 'Ganadora de Facebook FbStart - EMEA 2017',
  'hero.mondly.marketing.editorChoice': 'Elección del editor',
  'hero.mondly.marketing.googlePlay': 'Google Play',
  'header.menu.learnLanguage': 'Aprenda un idioma',
  'header.menu.moreAtPearson': 'Más en Pearson',
  'hero.subscriptionStatusTitle2': 'Sus recursos de Pearson+',
  'hero.startStudying': 'Comenzar a estudiar',
  'onboard.studyMaterials': 'Seleccione su materia y crearemos un tablero con material de estudio personalizado.',
  'hero.myETextbooks': 'Mis libros electrónicos',
  'header.continueInTheApp': 'Continuar en la aplicación',
  'hero.learnTxt': 'Aprender',
  'hero.examPrepTxt': 'Preparación para exámenes',
  'hero.aITutorTxt': 'Tutor con IA',
  'AI.toolTip': 'Pregúnteme sobre cualquier tema dentro de su libro de texto electrónico',
  'hero.studyExamPrepAllYourCourses': 'Preparación de estudio para todos sus cursos',
  'header.qrCode.subHeaderTxt': 'Utilice este código QR para iniciar sesión en la aplicación Pearson+ de manera rápida y segura en su dispositivo móvil.',
  'header.qrCode.dontHaveApp': '¿No tiene la aplicación?',
  'header.qrCode.footerTxt': 'Escanee este código para ir a la App Store o a Google Play. Una vez que descargue la aplicación, inicie sesión volviendo a escanear el código.',
  'header.qrCode.errorMsg': 'No se cargó el código QR. Cierre e intente nuevamente.',
  'hero.yourETextbook': 'Su libro de texto electrónico',
  'onboard.addCourseWithEtextBundle': 'Añadir curso con Preparación de estudio',
  'onboard.disableTooltipText': 'Se añadieron todos los cursos de Preparación de estudio',
  'subscriptionstatus.bundlecta': 'Acceder a Preparación de estudio',
  'subscriptionstatus.nonbundlecta': 'Acceder a Preparación de estudio',
  'channel.genericBundle': 'Use Preparación de estudio como apoyo para sus otros cursos',
  'channel.relatedBundle': 'Use Preparación de estudio como apoyo para sus otros cursos',
  'onboard.courseAdded': 'Se añadió el curso.',
  'hero.flashcards': 'Tarjetas didácticas',
  'relatedChannelCard.title': 'Mejore su aprendizaje con este recurso relacionado',
  'relatedChannelCard.badgeText': 'Preparación de estudio relacionado',
  'sessionInactivity.title': '¿Se encuentra ahí?',
  'sessionInactivity.description': 'Su sesión expira en <b>%TIMER%</b> por inactividad.<br/>¿Desea mantener la sesión abierta?',
  'sessionInactivity.keepMeSignIn': 'Seguir conectado',
  'sessionInactivity.signOut': 'Cerrar sesión',
  'sessionTimeout.title': 'La sesión expiró',
  'sessionTimeout.description': 'La sesión expiró por inactividad.',
  'print.qrCode.header': 'Utilice este código QR para abrir la aplicación Pearson+ en su dispositivo móvil.',
  'print.qrCode.footer': 'Escanee este código para ir a la App Store o a Google Play. Una vez que instale la aplicación, inicie sesión para descargar y tener acceso a su título.',
  'hero.nestest.title': 'Prepárese para su examen de certificación como maestro',
  'hero.nestest.subTitle': 'Los usuarios de Pearson+ ya pueden acceder a cursos de preparación y exámenes de práctica con alineación nacional para prepararse para sus exámenes de certificación como maestros.',
  'hero.channelAI.title': '¿Necesita ayuda? El tutor con IA tiene la respuesta.',
  'hero.channelAI.desc': 'Haga una pregunta y obtenga ayuda para su tarea paso a paso, recomendaciones de estudio y más. Obtenga ayuda personalizada siempre que lo necesite.',
  'hero.channelAI.action': 'Preguntar al tutor con IA',
  'new': '¡Nuevo!',
  'hero.practice.numOfUsers': 'Esta sección tiene <b>{practice_num_of_users}</b> problemas de práctica.',
  'hero.practice.cta': 'Practique ahora',
  'hero.practice.title': 'Problema de práctica',
  'diagnostics.errorMsg': 'No se cargó el diagnóstico. Cierre e intente nuevamente.',
  'qrcode.title': 'Empiece a estudiar en cualquier lugar',
  'qrcode.subtitle': 'Aprenda en cualquier momento y lugar con la aplicación móvil Pearson+. Descárguela ahora y obtenga una experiencia didáctica completa.',
  'qrcode.detailsv1': 'Con la aplicación Pearson+, puede usar este código QR para continuar en donde se quedó. Busque en su libro, estudie con tarjetas didácticas, vea lecciones en video y más, en cualquier lugar.',
  'qrcode.detailsv2': 'Escanee este código QR siempre que quiera iniciar sesión con rapidez y continuar en donde se quedó.',
  'qrcode.details': 'Con la aplicación Pearson+, puede usar este código QR para continuar en donde se quedó.',
  'qrcode.appstore': 'App Store',
  'qrcode.playstore': 'Google Play',
  'nativePromoBanner.description': 'Aprenda en cualquier momento y lugar con la aplicación móvil Pearson+. Descárguela ahora y obtenga una experiencia didáctica completa.',
  'install': 'Install',
  'header.menu.createCourse': 'Nuevo curso',
  'header.dropdown.courses': 'Cursos',
  'header.dropdown.recentlyViewed': 'Visto recientemente',
  'header.dropdown.viewAll': 'Ver todos los cursos',
  'aet.courseHeader.inviteStudents': 'Invitar estudiantes',
  'aet.courseHeader.inviteStudentModal.subTitle': 'Para invitar estudiantes a acceder a este libro de texto electrónico, copie la dirección del enlace o las instrucciones siguientes en su correo electrónico o temario.',
  'aet.courseHeader.inviteStudentModal.linkAddress': 'Dirección del enlace',
  'aet.courseHeader.inviteStudentModal.copyLink': 'Copiar enlace',
  'aet.courseHeader.inviteStudentModal.instructionsTitle': 'Instrucciones con la dirección del enlace',
  'aet.courseHeader.inviteStudentModal.copyInstructions': 'Copiar instrucciones',
  'aet.courseHeader.inviteStudentModal.instructionIntro': 'Es el momento de acceder a {bookTitle} el libro electrónico de {courseName}.\n\n',
  'aet.courseHeader.inviteStudentModal.instructionAccessLink': 'Cuando esté listo, abra su libro electrónico en: {enrollmentLink}\n\n',
  'aet.courseHeader.inviteStudentModal.instructionSignIn': 'Se le pedirá que inicie sesión con su cuenta actual de Pearson. Si no tiene una cuenta de Pearson, podrá crear una.\n\n',
  'aet.courseHeader.inviteStudentModal.instructionHelp': '¿Necesita ayuda?',
  'aet.courseHeader.inviteStudentModal.instructionHelpLink': 'AskPearson',
  'aet.courseHeader.startDate': 'Fecha de inicio:',
  'aet.courseHeader.endDate': 'Fecha de finalización:',
  'aet.courseHeader.start': 'Start:',
  'aet.courseHeader.end': 'End:',
  'aet.courseHeader.moreOptions': 'More options',
  'aet.courseHeader.entitlement': 'Entitlement:',
  'aet.courseHeader.format': 'Formato:',
  'aet.home.manageroster': 'Administrar lista',
  'aet.home.managegradesync': 'Administrar sincronización de calificaciones',
  'aet.home.copycourse': 'Copiar curso',
  'aet.home.unlinkcourse': 'Unlink course',
  'aet.tempAccess.warningBannerMessage': 'Temporary access expires on {date}',
  'aet.tempAccess.upgradeAccessLabel': 'Upgrade access',
  'aet.tempAccess.expiredTitle': 'Temporary access has expired',
  'aet.tempAccess.expiredWithActionDescription': 'Your progress has been saved. Upgrade your access now to continue where you left off.',

  'aet.instructorCourse.tabs.current': 'Actual',
  'aet.instructorCourse.tabs.past': 'Pasado',
  'aet.instructorCourse.tabs.courseSettings': 'Configuración del curso',
  'aet.instructorCourse.tabs.assignmentSettings': 'Assignment settings',
  'aet.instructorCourse.assignmentSettings.lmsAlertMessage': 'Important: Your LMS may also have assignment scoring settings. Changes in both places are applied together. To avoid unintended changes to final scoring, update settings in one place.',
  'aet.instructorCourse.assignmentSettings.gradebookSectionTitle': 'Display assignment scores in gradebook as',
  'aet.instructorCourse.assignmentSettings.gradebookInfoButtonAriaLabel': 'Learn about raw score and equal weighting',
  'aet.instructorCourse.assignmentSettings.rawScoreTitle': 'Raw score',
  'aet.instructorCourse.assignmentSettings.rawScoreDescription': 'Assignment scores vary based on the number of questions in each assignment.',
  'aet.instructorCourse.assignmentSettings.equalWeightingTitle': 'Equal weighting',
  'aet.instructorCourse.assignmentSettings.equalWeightingDescription': 'All assignments have the same base value.',
  'aet.instructorCourse.assignmentSettings.baseValueLabel': 'Base value:',
  'aet.instructorCourse.assignmentSettings.availabilitySectionTitle': 'Assignment availability',
  'aet.instructorCourse.assignmentSettings.availabilityFieldLabel': 'Assignments are available to students',
  'aet.instructorCourse.assignmentSettings.dueDatesSectionTitle': 'Scheduling defaults',
  'aet.instructorCourse.assignmentSettings.defaultDueTimeLabel': 'Default due time',
  'aet.instructorCourse.assignmentSettings.courseTimeZoneLabel': 'Course time zone',
  'aet.instructorCourse.assignmentSettings.cancelButtonLabel': 'Cancel',
  'aet.instructorCourse.assignmentSettings.saveButtonLabel': 'Save changes',
  'aet.instructorCourse.assignmentSettings.gradebookInfoModalTitle': 'Raw Score vs Equal Weighting',
  'aet.instructorCourse.assignmentSettings.gradebookInfoRawScoreHeading': 'Raw Score:',
  'aet.instructorCourse.assignmentSettings.gradebookInfoRawScoreBody': 'Grades reflect total points earned out of total points possible across all assignments. Longer or higher-point assignments naturally impact the final grade more.',
  'aet.instructorCourse.assignmentSettings.gradebookInfoEqualWeightingHeading': 'Equal Weighting:',
  'aet.instructorCourse.assignmentSettings.gradebookInfoEqualWeightingBody': 'Every assignment is normalized using a consistent base value so that each task contributes equally to the final grade, regardless of length or point total.',
  'aet.instructorCourse.assignmentSettings.baseValueRequired': 'Base value is required',
  'aet.instructorCourse.assignmentSettings.baseValueInvalid': 'Enter a value between 1 and 100',
  'aet.instructorCourse.assignmentSettings.availability.immediate': 'Immediately upon publish',
  'aet.instructorCourse.assignmentSettings.availability.fourWeeksBefore': '4 weeks before due date',
  'aet.instructorCourse.assignmentSettings.availability.twoWeeksBefore': '2 weeks before due date',
  'aet.instructorCourse.assignmentSettings.availability.oneWeekBefore': '1 week before due date',
  'aet.instructorCourse.tabs.manageRoster': 'Administrar lista',
  'aet.instructorCourse.currentCourses.title': 'Cursos actuales',
  'aet.instructorCourse.pastCourses.title': 'Cursos pasados',
  'aet.instructorCourse.archivedCourses.title': 'Archived courses',
  'aet.instructorCourse.archivedCourses.description': 'Archived titles are hidden from Current and Past. Your access to each title doesn’t change — unarchive it any time to put it back on your bookshelf.',
  'aet.instructorCourse.archivedCourses.emptyStateTitle': 'No archived titles',
  'aet.instructorCourse.archivedCourses.emptyStateDescription': 'Archive a title from Current or Past using its ··· menu. It moves here without changing your access.',
  'aet.instructorCourse.archiveDialog.title': 'Archive title(s)',
  'aet.instructorCourse.archiveDialog.description': 'Archived titles will move to the Archived tab, and all courses that use that title will be archived. They can still be accessed from the archived section, directly from the MLM course, and from Console. You can unarchive it anytime from the Archived tab.',
  'aet.instructorCourse.archiveDialog.confirmCTA': 'Archive',
  'aet.instructorCourse.unarchiveDialog.title': 'Unarchive title(s)',
  'aet.instructorCourse.unarchiveDialog.description': 'Unarchived titles will be accessible from your home page.',
  'aet.instructorCourse.unarchiveDialog.confirmCTA': 'Unarchive',
  'aet.home.archiveCourse': 'Archive',
  'aet.home.unarchiveCourse': 'Unarchive',
  'aet.instructorCourse.createOrCopy.title': 'Crear o copiar un curso de un libro electrónico de Pearson',
  'aet.instructorCourse.createOrCopy.sectionTitle': 'Copiar el curso de otro instructor o crear uno nuevo',
  'aet.instructorCourse.createOrCopy.copyPanel.title': 'Copiar el curso de otro instructor',
  'aet.instructorCourse.createOrCopy.copyPanel.subtitle': 'Escriba el identificador de curso para encontrar el curso que desea copiar.',
  'aet.instructorCourse.createOrCopy.copyPanel.courseIdLabel': 'Identificador del curso',
  'aet.instructorCourse.createOrCopy.copyPanel.courseIdPlaceholder': 'Escriba el identificador del curso',
  'aet.instructorCourse.createOrCopy.copyPanel.searchedForPrefix': 'Usted buscó',
  'aet.instructorCourse.createOrCopy.catalogPanel.title': 'Crear un curso nuevo del catálogo',
  'aet.instructorCourse.createOrCopy.catalogPanel.subtitle': 'Buscar por título, autor, ISBN o palabras clave de la materia',
  'aet.instructorCourse.createOrCopy.catalogPanel.searchPlaceholder': 'Buscar...',
  'aet.instructorCourse.createOrCopy.showMoreLabel': 'Mostrar más',
  'aet.instructorCourse.createOrCopy.showLessLabel': 'Mostrar menos',
  'aet.instructorCourse.cancel': 'CANCELAR',
  'aet.instructorCourse.loading': 'Cargando...',
  'aet.instructorCourse.courseForm.copyError': 'Your course cannot be copied because the title is no longer supported. Please contact your Pearson representative or customer support.',
  'aet.instructorCourse.courseForm.gradeSync': 'Sincronizar calificaciones',
  'aet.instructorCourse.courseForm.gradeSyncLinkLabel': 'Administrar sincronización de calificaciones',
  'aet.instructorCourse.courseForm.courseNameLabel': 'Nombre del curso',
  'aet.instructorCourse.courseForm.courseNamePlaceholder': 'Sin título',
  'aet.instructorCourse.courseForm.sectionNameLabel': 'Nombre de la sección',
  'aet.instructorCourse.courseForm.sectionNamePlaceholder': 'Sin título',
  'aet.instructorCourse.courseForm.institutionFieldLabel': 'Institución',
  'aet.instructorCourse.courseForm.institutionSelectLabel': 'Select an Institution',
  'aet.instructorCourse.courseForm.institutionPlaceholder': 'Start typing your institution',
  'aet.instructorCourse.courseForm.institutionRequiredError': 'La institución es obligatoria',
  'aet.instructorCourse.courseForm.institutionSearchError': 'Algo salió mal. Inténtelo de nuevo.',
  'aet.instructorCourse.courseForm.institutionNoResults': 'No hay resultados',
  'aet.instructorCourse.courseForm.findAnotherInstitutionLabel': 'Find another institution',
  'aet.instructorCourse.courseForm.higherEducationSectionLabel': 'Higher Education:',
  'aet.instructorCourse.courseForm.k12InstitutionsSectionLabel': 'K12 Institutions:',
  'aet.instructorCourse.courseForm.k12InstitutionsDescription': 'Go to your My Courses dashboard to create courses for this type of institution',
  'aet.instructorCourse.courseForm.createK12CourseLabel': 'Create K-12 course',
  'aet.instructorCourse.courseForm.startDateLabel': 'Fecha de inicio del curso',
  'aet.instructorCourse.courseForm.endDateLabel': 'Fecha de finalización del curso',
  'aet.instructorCourse.courseForm.datePlaceholder': 'dd/mm/aa',
  'aet.instructorCourse.courseForm.allowCopyLabel': 'Permitir que otros copien este curso',
  'aet.instructorCourse.courseForm.shareCodeLabel': 'Comparta este código con los instructores que quieran copiar este curso',
  'aet.instructorCourse.courseForm.copyCodeLabel': 'Copiar código',
  'aet.instructorCourse.courseForm.optionalSuffix': '(opcional)',
  'aet.instructorCourse.courseForm.formValidationLiveRegion': 'El formulario tiene errores de validación',
  'aet.instructorCourse.courseForm.submitContinue': 'Continuar',
  'aet.instructorCourse.courseForm.submitContinueLoading': 'Guardando...',
  'aet.instructorCourse.courseForm.submitError': 'No pudimos crear su curso. Inténtelo de nuevo.',
  'aet.instructorCourse.courseForm.submitEditError': 'No pudimos guardar sus cambios. Inténtelo de nuevo.',
  'aet.instructorCourse.courseForm.submitSaveChanges': 'Guardar cambios',
  'aet.instructorCourse.courseForm.materialsHeader': 'Materiales del curso',
  'aet.instructorCourse.courseForm.resolveError': 'No pudimos cargar los materiales del curso. Inténtelo de nuevo.',
  'aet.instructorCourse.courseForm.copySourceError': 'We could not load the course to copy. Please search again from Create or copy course.',
  'aet.instructorCourse.coursesSort.lastViewed': 'Últimos vistos',
  'aet.instructorCourse.coursesSort.recentlyAdded': 'Agregado recientemente',
  'aet.instructorCourse.coursesSort.aToZ': 'De la A a la Z',
  'aet.instructorCourse.coursesSort.zToA': 'De la Z a la A',
  'aet.instructorCourse.manageRoster.column.name': 'Nombre',
  'aet.instructorCourse.manageRoster.column.role': 'Función',
  'aet.instructorCourse.manageRoster.column.email': 'Correo electrónico',
  'aet.instructorCourse.manageRoster.column.access': 'eTextbook Access',
  'aet.instructorCourse.manageRoster.column.status': 'Estado',
  'aet.instructorCourse.manageRoster.column.statusInfoTooltip': 'Status information',
  'aet.instructorCourse.manageRoster.statusInfoModal.title': 'Status',
  'aet.instructorCourse.manageRoster.statusInfoModal.bodyParagraph1': 'This status reflects Pearson enrollment and may not match a student\'s enrollment status in your linked LMS course.',
  'aet.instructorCourse.manageRoster.statusInfoModal.bodyParagraph2': 'Students marked as Inactive will not have grades synced back to the LMS.',
  'aet.instructorCourse.manageRoster.access.tempAccessTitle': 'Temporary access',
  'aet.instructorCourse.manageRoster.access.active': 'Active eTextbook access',
  'aet.instructorCourse.manageRoster.access.endsOn': 'Ends: {date}',
  'aet.instructorCourse.manageRoster.access.ended': 'Ended:',
  'aet.instructorCourse.manageRoster.changeTo': 'Change to:',
  'aet.instructorCourse.manageRoster.notAvailable': '---',
  'aet.instructorCourse.roster.role.student': 'Alumno',
  'aet.instructorCourse.roster.role.ta': 'Maestro asistente',
  'aet.instructorCourse.roster.role.instructor': 'Instructor',
  'aet.instructorCourse.roster.status.active': 'Activo',
  'aet.instructorCourse.roster.status.inactive': 'Inactivo',
  'aet.instructorCourse.manageRoster.filter.allMembers': 'Todos los miembros',
  'aet.instructorCourse.manageRoster.filter.activeStudents': 'Estudiantes activos',
  'aet.instructorCourse.manageRoster.filter.inactiveStudents': 'Estudiantes inactivos',
  'aet.instructorCourse.manageRoster.filter.teachingAssistant': 'Maestro asistente',
  'aet.instructorCourse.manageRoster.filter.instructor': 'Instructor',
  'aet.instructorCourse.courseForm.materialsAuthorLabel': 'Autor:',
  'aet.instructorCourse.courseForm.materialsIsbnLabel': 'ISBN:',
  'aet.instructorCourse.courseForm.materialsCreationDateLabel': 'Fecha de creación del curso:',
  'aet.instructorCourse.noCoursesFound': 'No se encontraron cursos',
  'aet.instructorCourse.searchNoResultsTitle': 'No courses match “{searchTerm}”',
  'aet.instructorCourse.searchNoResultsDescription': 'Try a different course name.',
  'aet.instructorCourse.clearSearch': 'Clear search',
  'aet.instructorCourse.noCoursesEmptyStateTitle': 'Nothing here yet',
  'aet.instructorCourse.noCoursesEmptyStateDescription': 'Courses you create or are added to will appear here.',
  'aet.instructorCourse.backButton': 'Atrás',
  'aet.instructorCourse.selectCourse': 'Seleccionar curso',
  'aet.home.linkedToLms': 'Enlazado con el LMS',
  'aet.instructorCourse.courseForm.title.create': 'Crear curso',
  'aet.instructorCourse.courseForm.title.copy': 'Copiar curso',
  'aet.instructorCourse.courseForm.title.edit': 'Información del curso',
  'aet.instructorCourse.courseForm.copiedContentAccordion.settings.title': 'Configuración',
  'aet.studentRoster.manageStudentRosterButton': 'Administrar lista de estudiantes',
  'aet.studentRoster.dontHaveAnyStudent': 'Looks like you don’t have any students.',
  'aet.studentRoster.lmsEmptyState.title': 'No students have accessed the course yet',
  'aet.studentRoster.lmsEmptyState.description': 'As soon as students click through from your LMS, you’ll see their names and progress here.',
  'aet.studentRoster.nonlmsEmptyState.description': 'As soon as students join your course, you’ll see their names and progress here.',
  'aet.syllabus.editContentDisabledTooltip': 'Cannot update assignment while student work is in progress.',
  'aet.assignments.exportStudentProgressButton': 'Exportar progreso de los estudiantes',
  'aet.home.student.roaster.enrolmentInformationTitle': 'Enrolment information',
  'aet.home.student.roaster.enrolmentInformation.status': 'Estado:',
  'aet.home.student.roaster.enrolmentInformation.enrolled': 'Inscrito:',
  'aet.home.student.roaster.enrolmentInformation.access': 'Access:',
  'aet.home.student.roaster.enrolmentInformation.role': 'Función:',
  'aet.home.student.roaster.enrolmentInformation.promotionCardTitle': '¿Promover a {studentName}?',
  'aet.home.student.roaster.enrolmentInformation.promotionCardContent1': 'Como maestro asistente, esta persona podrá ver el progreso y desempeño de todos los estudiantes de la clase.',
  'aet.home.student.roaster.enrolmentInformation.promotionCardContent2': 'También podrá administrar estudiantes y asignaciones, pero no podrá borrar el grupo.',
  'aet.home.student.roaster.enrolmentInformation.promotionCardConfirmLabel': 'Promover a maestro asistente',
  'aet.home.manageRoster.searchPlaceholder': 'Buscar un estudiante',
  'aet.home.manageRoster.inactivateButtonLabel': 'Desactivar a los estudiantes seleccionados',
  'aet.home.manageRoster.FilterLabel': 'Show',
  'aet.home.manageRoster.updatingMessage': 'Actualizando lista... Esto puede tomar varios minutos.',
  'aet.home.courses.search.searchPlaceHolder': 'Buscar sus cursos',
  'aet.courses.emptyStateDescription': 'Para empezar a construir su curso, seleccione una de las opciones siguientes.',
  'nativePromoBanner.continueInBrowser': 'Continuar en el navegador',
  'globalnav.tooltip.hideNavText': 'Ocultar navegación',
  'globalnav.tooltip.showNavText': 'Mostrar navegación',
  'aet.syllabus.progressTitle': 'Extrayendo...',
  'aet.syllabus.progressDesc': 'Por favor espere mientras procesamos su temario.',
  'aet.syllabus.uploadInputLabel': 'Arrastre y suelte archivos o haga clic para cargarlos',
  'aet.syllabus.uploadSyllabusTabLabel': 'Cargar temario',
  'aet.syllabus.dateAdjusterTabLabel': 'Ajustador de fecha',
  'aet.syllabus.addManuallyTabLabel': 'Añadir asignaciones manualmente',
  'aet.syllabus.addEditLaterText': 'Usted siempre puede añadir y editar las asignaciones después',
  'aet.syllabus.editAssignmentLabel': 'Editar asignación',
  'aet.syllabus.addAssignmentLabel': 'Añadir asignación',
  'aet.syllabus.assignmentTitleLabel': 'Título de la asignación',
  'aet.syllabus.assignmentTitleAutoPlaceholder': 'Automatically generated',
  'aet.syllabus.dueDateLabel': 'Fecha de entrega',
  'aet.syllabus.editDueDateLabel': 'Editar fecha de entrega',
  'aet.syllabus.chaptersCoveredLabel': 'Seleccione los capítulos o las secciones a cubrir',
  'aet.syllabus.updateCtaLabel': 'Actualizar asignación',
  'aet.syllabus.addCtaLabel': 'Añadir asignación',
  'aet.syllabus.uploadLabel': 'Cargar',
  'aet.syllabus.confirmLabel': 'Confirmar',
  'aet.syllabus.addContentLabel': 'Añadir contenido',
  'aet.syllabus.addEditContentLabel': 'Añadir/editar contenido',
  'aet.syllabus.notPublishedLabel': 'No publicado',
  'aet.syllabus.updateDatesLabel': 'Actualizar fecha',
  'aet.syllabus.dateNormalization.yearAdjustedContentSingle': 'Se actualizó su fecha de entrega. Revísela, y luego publique.',
  'aet.syllabus.coverageDedupe.adjustedContent': 'Se actualizó la información de capítulo y sección. Revísela, y luego publique.',
  'aet.syllabus.unassignedCoverageStatus': 'Algunos capítulos aún no se han asignado. Asígnelos antes de publicar.',
  'aet.syllabus.dateNormalization.manualEntryContent': 'Add a due date before you publish.',
  'aet.syllabus.pastDuePublishStatus': 'Update due date before you publish.',
  'aet.deleteAssignmentTitle': '¿Eliminar asignación?',
  'aet.deleteAssignmentTitleMultiple': '¿Eliminar asignaciones?',
  'aet.deleteAssignmentWarning': 'Esta acción no puede deshacerse, y todos los envíos y datos de estudiantes asociados ya no serán visibles.',
  'aet.deleteAssignmentKeepCTA': 'Conservar asignación',
  'aet.deleteAssignmentDeleteCTA': 'ELIMINAR',
  'aet.assignments.loadingAsset': 'Cargando recurso...',
  'aet.assignments.addToDate': 'Añadir a la fecha',
  'aet.assignments.previewAsStudent': 'Vista previa como estudiante',
  'aet.assignments.questionsAndTopics': 'Preguntas y temas',
  'aet.assignments.questionsAndTopicsModal.doneLabel': 'Listo',
  'aet.assignments.questionsAndTopicsModal.dueDateLabel': 'Fecha de entrega',
  'aet.assignments.questionsAndTopicsModal.questionsTotalLabel': 'Total de preguntas',
  'aet.assignments.questionsAndTopicsModal.questionOfTotalLabel': 'Pregunta {count} de {total}',
  'aet.assignments.questionsAndTopicsModal.sectionSelectLabel': 'Select a section',
  'aet.assignments.publishToStudents': 'Publicar para los estudiantes',
  'aet.assignments.availableToStudentsOn': 'Available to students on {0}',
  'aet.syllabus.addDateLabel': 'Añadir fecha',
  'aet.assistedSchedule.addToAssignmentModalTitle': 'Add to assignment',
  'aet.assistedSchedule.addToAssignmentModalEmptyLabel': 'No content yet',
  'aet.doneLabel': 'Listo',
  'aet.assignments.dueDateLabel': 'Fecha de entrega de la asignación',
  'aet.assignmentNameLabel': 'Assignment name',
  'aet.assignment.nameDisabledPlaceholder': 'Add content to generate a default name for your assignment',
  'aet.assignment.nameGeneratedPlaceholder': 'Automatically generated assignment name based on selected content',
  'aet.onboarding.getStarted.title': 'Get started creating assignments now:',
  'aet.onboarding.getStarted.manualSetup.title': 'Configuración manual',
  'aet.onboarding.getStarted.manualSetup.description': 'Create and customize individual reading assignments and set their due dates',
  'aet.onboarding.getStarted.manualSetup.ctaLabel': 'Create manually',
  'aet.onboarding.getStarted.assistedScheduling.title': 'Weekly schedule',
  'aet.onboarding.getStarted.assistedScheduling.description': 'Pick a due day that repeats all term, then drag chapters into each week',
  'aet.onboarding.getStarted.assistedScheduling.ctaLabel': 'Build schedule',
  'aet.onboarding.getStarted.autoCreateAssignments.title': 'Auto-create assignments',
  'aet.onboarding.getStarted.autoCreateAssignments.description': 'Upload your syllabus to generate all reading assignments in seconds',
  'aet.onboarding.promotion.title': 'Turn assigned reading into active learning',
  'aet.onboarding.promotion.feature.1': 'Quickly create assignments with embedded questions, plus optional grade sync to your LMS',
  'aet.onboarding.promotion.feature.2': 'Use ideas en tiempo real para detectar las brechas en el aprendizaje, para que pueda actuar con rapidez y confianza.',
  'aet.onboarding.promotion.feature.3': 'Los estudiantes reciben más apoyo con la retroalimentación dirigida y la IA integrada de Pearson',
  'aet.onboarding.getStarted.previewQuestions.prompt': 'Want to see what’s available?',
  'aet.onboarding.getStarted.previewQuestions.link': 'Preview all questions',
  'aet.questionPreview.title': 'Preview questions',
  'aet.questionPreview.chapterSelectLabel': 'Select chapter',
  'aet.questionPreview.questionLabel': 'question',
  'aet.questionPreview.questionsLabel': 'questions',
  'aet.questionPreview.correctAnswer': 'Correct answer',
  'aet.questionPreview.noQuestions': 'No questions are available for this chapter.',
  'aet.assistedSchedule.pageTitle': 'Weekly schedule',
  'aet.assistedSchedule.reviewPageTitle': 'Create your assignments',
  'aet.assistedSchedule.sectionTitle': 'Set up a weekly schedule',
  'aet.assistedSchedule.sectionDescription': 'Tip: Make assignments due 1 or 2 days before your class meets in order to get the most out of assignment insights',
  'aet.assistedSchedule.dueDaysLabel': 'Have assignments due every',
  'aet.assistedSchedule.dueDaysTip': 'Tip: Make assignments due 1 or 2 days before your class meets in order to get the most out of assignment insights',
  'aet.assistedSchedule.dueDaysPlaceholder': 'Choose one or more days of the week',
  'aet.assistedSchedule.dueDaysRequiredError': 'Select at least one day',
  'aet.assistedSchedule.viewQuestions': 'View questions',
  'aet.assistedSchedule.dueTimeRequiredError': 'Due time is required',
  'aet.assistedSchedule.timeZoneRequiredError': 'Time zone is required',
  'aet.assistedSchedule.startDateLabel': 'Start assignments by',
  'aet.assistedSchedule.endDateLabel': 'End assignments by',
  'aet.assistedSchedule.datePlaceholder': 'mm/dd/yyyy',
  'aet.assistedSchedule.startDateRequiredError': 'Start date is required',
  'aet.assistedSchedule.endDateRequiredError': 'End date is required',
  'aet.assistedSchedule.scheduleInstruction': 'Drag content into the assignment slots to build your schedule.',
  'aet.assistedSchedule.dragZoneLabel': 'Drag content here to assign it to students',
  'aet.assistedSchedule.clickToEditLabel': 'Click to edit',
  'aet.assistedSchedule.clearDataLabel': 'Clear data',
  'aet.assistedSchedule.formValidationLiveRegion': 'Form has validation errors',
  'aet.assistedSchedule.noQuestionsError': 'Each assignment must include content with at least one question.',
  'aet.assistedSchedule.noQuestionsWarningLabel': 'Add content with at least 1 question to save this assignment.',
  'aet.assistedSchedule.autoNameAssignmentsLabel': 'Automatically name assignments based on content',
  'aet.assistedSchedule.autoNameAssignmentsInstruction': 'Assignment names will be generated from the content.',
  'aet.assistedSchedule.noAssignmentsModalTitle': 'No assignments can be created',
  'aet.assistedSchedule.noAssignmentsModalMessage': 'The selected date range is too short to generate any assignments. Extend the date range and try again.',
  'aet.assistedSchedule.addNewLabel': 'Add new',
  'aet.assistedSchedule.addToNewAssignmentLabel': 'Add to new assignment',
  'aet.assistedSchedule.saveAsDraftLabel': 'Save as draft',
  'aet.assistedSchedule.saveAndPublishLabel': 'Save and publish',
  'aet.assignments.allCaughtUpDescription': 'No tiene asignaciones pendientes esta semana.',
  'aet.assignments.progressTitle': 'Progreso',
  'aet.assignments.performanceTitle': 'Confianza',
  'aet.assignments.completionTitle': 'Conclusión',
  'aet.assignments.statusTitle': 'Estado',
  'aet.assignments.addTooltip': 'Añadir asignación',
  'aet.assignments.deleteTooltip': 'Eliminar asignaciones seleccionadas',
  'aet.assignments.selectToDeleteLabel': 'Modo de seleccionar y eliminar',
  'aet.assignments.bulkEditTooltip': 'Editar asignaciones en bloque',
  'aet.assignments.title': 'Asignaciones',
  'aet.assignments.assignmentTitle': 'Tarea',
  'aet.assignments.dueDate': 'Fecha de entrega',
  'aet.tabular.searchPlaceholder.assignments': 'Buscar asignaciones',
  'aet.tabular.searchPlaceholder.students': 'Buscar estudiantes',
  'aet.tabular.searchPlaceholder.questions': 'Buscar preguntas',
  'aet.assignemnts.columnDueDateInfoTooltip': 'Uno o más estudiantes tienen prórrogas en las fechas de entrega de todas las asignaciones',
  'aet.assignemnts.singleDueDateInfoTooltip': 'Uno o más estudiantes tienen prórrogas en las fechas de entrega de esta asignación',
  'aet.assignemnts.masterDueDateInfoTooltip': 'Uno o más estudiantes han recibido prórrogas en las fechas de entrega. Busque el ícono de Información para identificar en cuáles asignaciones.',
  'aet.home.loading': 'Cargando...',
  'aet.home.errorFetchingAssignments': 'Error al obtener las asignaciones',
  'aet.home.dueThisWeekTitle': 'Se entrega esta semana',
  'aet.home.allCaughtUpTitle': '¡Ya está al corriente!',
  'aet.home.allCaughtUpDescription': 'No tiene asignaciones pendientes esta semana.',
  'aet.home.suggestedRemediationTitle': 'Revisión sugerida por Preparación de estudio',
  'aet.home.noSuggestedRemediationTitle': 'No hay material de revisión sugerido',
  'aet.home.noSuggestedRemediationDescription': 'Vuelva a revisar después de su siguiente asignación.',
  'aet.home.assignmentIncludesTitle': 'La asignación incluye',
  'aet.home.sectionsLabel': 'Capítulo(s)',
  'aet.home.questionsCount': '{count} preguntas',
  'aet.home.dueLabel': 'Fecha de entrega: {dueDate}',
  'aet.home.due': 'Fecha de entrega:',
  'aet.home.progressCompletedLabel': 'Terminado',
  'aet.home.progressCompletedPastDueLabel': 'Terminado con retraso',
  'aet.home.progressInProgressLabel': 'En proceso',
  'aet.home.progressPartiallyCompleteLabel': 'Partially complete',
  'aet.home.progressNotStartedLabel': 'No iniciado',
  'aet.home.progressCountOfTotal': '{count} de {total}',
  'aet.home.NotAttemptedLabel': 'No intentado',
  'aet.home.questionsTotalLabel': 'Total de preguntas',
  'aet.home.progressCompletedOnTimeLabel': 'Terminado a tiempo',
  'aet.home.segmentGreatLabel': 'Excelente',
  'aet.home.segmentGettingThereLabel': 'Okay',
  'aet.home.segmentNeedsReviewLabel': 'Necesita mejorar',
  'aet.home.segmentOkayLabel': 'Okay',
  'aet.home.editAssignmentTooltip': 'Editar asignación',
  'aet.home.deleteAssignmentTooltip': 'Eliminar asignación',
  'aet.home.viewDetailsButton': 'Ver detalles',
  'aet.home.viewAsStudentButton': 'Ver como estudiante',
  'aet.home.welcomeButtonText': 'Comenzar →',
  'aet.review.emptyStateTitle': 'No hay nada que repasar.',
  'aet.review.emptyStateDescription': 'Vuelva a revisar después de su siguiente asignación.',
  'aet.dashboard.tabs.upNext': 'A continuación',
  'aet.dashboard.tabs.welcome': 'Bienvenido',
  'aet.dashboard.tabs.assignments': 'Asignaciones',
  'aet.dashboard.tabs.review': 'Revisar',
  'aet.dashboard.tabs.studentRoster': 'Estudiantes',
  'aet.dashboard.classSchedule': 'Horario de clase:',
  'aet.syllabus.dueTimeLabel': 'Hora de entrega',
  'hero.accessEducatorGuides': 'Acceder a guías del educador',
  'aet.assignment.save': 'Guardar',
  'aet.assignment.finish': 'Finalizar',
  'aet.assignment.saveAndAdd': 'Guardar y añadir otro',
  'aet.assignment.delete': 'ELIMINAR',
  'aet.assignment.saveAndClose': 'Guardar y cerrar',
  'aet.studentRoster.title': 'Estudiantes',
  'aet.studentRoster.titlev1': 'Alumno',
  'aet.studentRoster.dueDatesAdjustmentLabel': 'Fechas de entrega',
  'aet.studentRoster.dueDateAdjustment.option.0': 'Estándar',
  'aet.studentRoster.dueDateAdjustment.option.2': '+2 días',
  'aet.studentRoster.dueDateAdjustment.option.3': '+3 días',
  'aet.studentRoster.dueDateAdjustment.option.5': '+5 días',
  'aet.studentRoster.dueDateAdjustment.option.week.1': '+1 semana',
  'aet.studentRoster.dueDateAdjustment.option.week.2': '+2 semanas',
  'aet.studentRoster.dueDateAdjustment.option.lastDayOfClass': 'Ultimo día de clases',
  'aet.studentRoster.dueDateAdjustment.toast.partial.title.multiple': '{count} of {total} assignments updated',
  'aet.studentRoster.dueDateAdjustment.toast.partial.message': '{skippedCount} assignments are past due. Edit manually to set new due dates.',
  'aet.studentRoster.dueDateAdjustment.toast.allPastDue.title': 'No assignments updated',
  'aet.studentRoster.dueDateAdjustment.toast.allPastDue.message': 'All assignments are past due. Edit manually to set new due dates.',
  'aet.studentRoster.dueDateAdjustment.toast.success.title.multiple': '{count} assignments updated',
  'aet.studentRoster.dueDateAdjustment.toast.success.message.single': 'New due dates have been added to <b>{assignmentTitle}</b>.',
  'aet.studentRoster.dueDateAdjustment.toast.success.message.multiple': 'New due dates have been added to multiple assignments.',
  'aet.bulkEdit.bulkSplitInstruction': 'Dividiremos sus asignaciones de forma uniforme.',
  'aet.bulkEdit.Description': 'Figma ipsum component variant main layer. Editor library device auto star reesizing pencil horizontal. Polygon main list figjam star layout object connection hand scale.',
  'aet.bulkEdit.firstAssignmentDue': 'Fecha de entrega de la primera asignación',
  'aet.bulkEdit.lastAssignmentDue': 'Fecha de entrega de la última asignación',
  'aet.bulkEdit.assignmentsDueDays': '¿En que días desea que sean las entregas de las asignaciones?',
  'aet.bulkEdit.addEditLaterText': 'Usamos IA para crear asignaciones. Usted siempre puede añadir y editar las asignaciones después.',
  'aet.bulkEdit.monday': 'Lunes',
  'aet.bulkEdit.tuesday': 'Martes',
  'aet.bulkEdit.wednesday': 'Miércoles',
  'aet.bulkEdit.thursday': 'Jueves',
  'aet.bulkEdit.friday': 'Viernes',
  'aet.bulkEdit.saturday': 'Sábado',
  'aet.bulkEdit.sunday': 'Domingo',
  'aet.toast.assignmentCreated.title': '1 assignment created',
  'aet.toast.assignmentCreated.title.multiple': '{count} assignments created',
  'aet.toast.assignmentCreated.single': 'Assignment was named <b>{assignmentTitle}</b>.',
  'aet.toast.assignmentCreated.multiple': 'Assignment names were also added.',
  'aet.toast.assignmentUpdated.title': 'Actualizado correctamente.',
  'aet.toast.assignmentUpdated.title.single': '1 assignment updated',
  'aet.toast.assignmentUpdated.single': 'Your changes have been saved to <b>{assignmentTitle}</b>.',
  'aet.toast.assignmentUpdated.multiple': '{count} asignaciones han sido actualizadas',
  'aet.toast.assignmentPublished.single': '{count} assignment published',
  'aet.toast.assignmentPublished.multiple': '{count} assignments published',
  'aet.toast.assignmentPublished.subtitle': 'El contenido de la asignación puede editarse hasta que los estudiantes empiecen a trabajar.',
  'aet.toast.assistedScheduleCreated.single': '{count} Assignment created!',
  'aet.toast.assistedScheduleCreated.multiple': '{count} Assignments created!',
  'aet.toast.assistedScheduleCreated.subtitle': 'Default assignment titles were updated based on content.',
  'aet.toast.assistedSchedulePublished.single': '{count} Assignment published!',
  'aet.toast.assistedSchedulePublished.multiple': '{count} Assignments published!',
  'aet.toast.viewAssignment': 'Ver asignación',
  'aet.toast.viewAssignments': 'Ver asignaciones',
  'aet.welcome.title': 'Su libro de texto electrónico de Pearson ya está vinculado con su curso del LMS',
  'aet.welcome.LMSAccounTitle': 'Explore información de los estudiantes',
  'aet.welcome.LMSAccounDescription': 'Vea exactamente con qué temas tiene problemas su grupo.',
  'aet.welcome.createAssignmentsTitle': 'Crear asignaciones',
  'aet.welcome.createAssignmentsDescription': 'Asigne capítulos manualmente o cargando su plan de estudios.',
  'aet.welcome.progressViewTitle': 'Haga seguimiento del desempeño en su LMS',
  'aet.welcome.progressViewDescription': 'Elija ajustes de sincronización de calificaciones en su curso del LMS.',
  'aet.assignmentDetails.noAssignmentFound': 'No se encontró la asignación',
  'aet.assignments.loadingErrorTitle': 'La asignación no puede cargarse por ahora',
  'aet.assignments.loadingErrorDescription': 'Trate de recargar la página o vuelva a consultar más tarde.',
  'aet.assignmentStudentDetails.noDataFound': 'Aún no hay datos',
  'aet.assignmentStudentDetails.noData': 'No data',
  'aet.studentRoster.noStudentsRegisteredYet': 'No hay estudiantes inscritos',
  'aet.studentRoster.noStudentsRegisteredYetDescription': 'Los estudiantes se unirán a su grupo cuando compren el libro de texto electrónico.',
  'aet.home.editAssignmentTooltipDisabled': 'No puede editarse: el trabajo del estudiante está en curso',
  'aet.home.deleteAssignmentTooltipDisabled': 'No puede eliminarse: el trabajo del estudiante está en curso',
  'aet.home.StudentDetails.questions': 'Preguntas',
  'aet.home.StudentDetails.attempts': 'Intentos',
  'aet.home.StudentDetails.comprehension': 'Confianza',
  'hero.titleInfo.tooltip': 'Información del título',
  'aet.home.publishAssignments': 'Publicar todas las asignaciones',
  'aet.assignments.saveScheduleAsDraft': 'Guardar el programa como borrador',
  'aet.assignments.reviewBeforePublishAlert': 'Revise sus asignaciones, y luego publíquelas para que los estudiantes puedan verlas.',
  'aet.assignments.copiedCoursePublishAlert': 'Añada fechas a sus asignaciones copiadas y publíquelas para que los estudiantes puedan verlas.',
  'aet.assignments.allSetPublishAlert': '¿Todo listo? Publique sus asignaciones para que los estudiantes puedan verlas.',
  'aet.assignments.emptyStateTitle': 'No assignments yet',
  'aet.assignments.emptyStateDescription': 'Assignments you create will appear here',
  'aet.dashboard.footer': 'Alguna parte del contenido es creado con IA en función del material de aprendizaje de Pearson. Aunque Pearson cuenta con un proceso para validar el resultado, es posible que la IA generativa produzca información inexacta sobre personas, lugares o hechos.',
  'aet.home.bulkEditTitle': 'Editar asignaciones en bloque',
  'aet.home.bulkEditSubtitle': 'Haga sus cambios a su temario, y vuelva a cargarlo aquí. Sus asignaciones y fechas de entrega se cambiarán en consecuencia.',
  'aet.home.createAssignmentTitle': 'Crear asignaciones',
  'aet.assignments.includedInAnotherAssignmentTooltip': 'Incluido en otra asignación',
  'aet.assignments.someSectionsIncludedInAnotherAssignmentTooltip': 'Algunas secciones se incluyen en otra asignación',
  'aet.welcome.welcome.Title': '¡Bienvenido!',
  'aet.home.student.roaster.ProgressTitle': 'Avance total',
  'aet.assignmentStudentDetails.startAssignmentDescription': 'Vuelva a consultar cuando los estudiantes inicien la asignación.',
  'aet.home.whatDueThisWeekTitle': 'Estos son los pendientes de esta semana',
  'aet.assignments.edit.errorTitle': '{count} asignaciones tienen errores',
  'aet.assignments.edit.errorSubTitle': 'Las asignaciones con errores no pueden publicarse. Edítelas o publíquelas sin ellos.',
  'aet.assignments.edit.publishAnyway': 'Publicar de cualquier modo',
  'aet.assignments.edit.editAssignments': 'Editar asignaciones',
  'aet.assignments.edit.validationInfoToolTip': 'Editar asignación para eliminar errores',
  'aet.assignments.error.assignmentCreated.title': 'Todas las asignaciones tienen errores',
  'aet.assignments.error.assignmentCreated.description': 'Las asignaciones con errores no pueden publicarse. Edítelas o pruebe con un temario diferente.',
  'aet.assignments.error.uploadSyllabus': 'Cargar temario',
  'aet.assignments.error.editAssignments': 'Editar asignaciones',
  'aet.mondly.title': 'Idiomas',
  'aet.studentRoster.errorState.title': 'Lista de estudiantes no disponible',
  'aet.studentRoster.errorState.description': 'No pudimos cargar su lista de estudiantes. Trate de recargar la página o vuelva a consultar más tarde.',
  'aet.assignments.sectionLabel': 'sección(es)',
  'aet.assignments.sectionLabelCapitalized': 'Section(s):',
  'aet.assignments.sectionsPrefix': 'Sections:',
  'aet.assignments.tags.dueNext': 'Due next',
  'aet.assignments.tags.pastDue': 'Past due',
  'aet.assignments.completionLabel': 'answered',
  'aet.assignments.chaptersPrefix': 'Chapters:',
  'aet.assignments.questionsLabel': 'pregunta(s)',
  'aet.assignments.assignmentsLabel': 'asignación(es)',
  'aet.assignments.performanceProgressBar': 'Barra de progreso del desempeño',
  'aet.assignments.completionProgressBar': 'Barra de progreso del avance',
  'aet.syllabus.deleteConfirmationSubtitleSingle': '¿Está seguro de que desea eliminar esta asignación?',
  'aet.syllabus.deleteConfirmationSubtitleBulk': '¿Está seguro de que desea eliminar estas asignaciones?',
  'aet.home.nextAssignmentTitle': 'Siguiente asignación',
  'aet.home.courseSettings': 'Configuración del curso',
  'aet.home.assignmentSettings': 'Assignment settings',
  'aet.home.pearsonETextbookResources': 'Recursos de libros de texto electrónicos de Pearson+',
  'aet.home.etextbookInformation': 'Información sobre el libro de texto electrónico',
  'aet.multiple.deleteAssignmentKeepCTA': 'Conservar asignación(es)',
  'aet.syllabus.processingText.header': 'Estamos organizando las lecturas asignadas para su clase – esto tomará solo un momento.',
  'aet.syllabus.processingText.uploading': 'Cargando su documento',
  'aet.syllabus.processingText.activating': 'Activando componentes de IA',
  'aet.syllabus.processingText.extracting': 'Extrayendo las lecturas asignadas',
  'aet.syllabus.processingText.mapping': 'Relacionando con el contenido del libro de texto',
  'aet.syllabus.processingText.finishing': 'Terminando',
  'aet.syllabus.uploadErrorMessage': 'Asegúrese de que su archivo PDF o .docx sea menor a 10 MB y que su conexión a internet sea estable',
  'aet.syllabus.uploadNoAssignmentsMessage': 'No se encontraron asignaciones de lectura.',
  'aet.syllabus.uploadNoAssignmentsDescription': 'No pudimos encontrar asignaciones de lectura en este archivo. Puede añadirlas manualmente.',
  'aet.syllabus.uploadFailedRetryCTA': 'Inténtelo de nuevo',
  'aet.syllabus.uploadModal.noAssignments.title': 'Couldn\'t find assignments',
  'aet.syllabus.uploadModal.noAssignments.body1': 'We weren\'t able to find any reading assignments within the uploaded syllabus.',
  'aet.syllabus.uploadModal.noAssignments.body2': 'Revise detenidamente que su temario tenga <qualities a syllabus should have for this to work> e inténtelo de nuevo, o cambie a creación manual de asignaciones.',
  'aet.syllabus.uploadModal.noAssignments.manualCreationCTA': 'Creación manual',
  'aet.syllabus.uploadModal.noAssignments.backToUploadCTA': 'Back to upload',
  'aet.syllabus.uploadModal.genericFailure.title': 'Algo salió mal.',
  'aet.syllabus.uploadModal.genericFailure.body1': 'No pudimos cargar y procesar el temario.',
  'aet.syllabus.uploadModal.genericFailure.body2': 'Revise su conexión e inténtelo de nuevo, o cambie a creación manual de asignaciones.',
  'aet.syllabus.uploadModal.successTotal.title': 'Listo para revisar',
  'aet.syllabus.uploadModal.successTotal.body1': 'We found {count} assignments from your syllabus.',
  'aet.syllabus.uploadModal.successTotal.body2': 'Make any adjustments, then save or publish when you\'re ready. You can continue making changes before students start working.',
  'aet.syllabus.uploadModal.successPartial.title': 'Listo para revisar',
  'aet.syllabus.uploadModal.successPartial.body1': 'We found {count} assignments from your syllabus.',
  'aet.syllabus.uploadModal.successPartial.body2': 'We couldn\'t find exact matches in the eTextbook for every item. Review your assignments to make any adjustments, then save or publish when you\'re ready.',
  'aet.syllabus.uploadModal.reviewAssignmentsCTA': 'Revisar asignaciones',
  'aet.syllabus.selectChapterWithQuestions': 'Seleccione un capítulo con preguntas.',
  'preferenceSetting.subTitle': 'Estos ajustes serán los predeterminados para todos los estudiantes de este curso.',
  'preferenceSetting.sections.isAIStudyEnabled.label': 'Interacciones con IA',
  'preferenceSetting.sections.isAIStudyEnabled.subLabel': 'Habilitar la herramienta de estudio con IA y los resúmenes de IA en los resultados de búsquedas',
  'preferenceSetting.sections.isStudyPrepEnabled.subLabel': 'Mostrar los recursos de preparación de estudio relacionados con este libro',
  'aet.syllabus.footer': 'La elaboración de asignaciones se realiza con IA',
  'aet.dashboard.footerDialogDeatils': 'Se utiliza IA generativa para elaborar preguntas de las asignaciones con base en el material de aprendizaje de Pearson. Aunque Pearson cuenta con un proceso para validar el resultado, es posible que la IA generativa produzca información inexacta sobre personas, lugares o hechos. También se utiliza IA para agrupar el contenido en asignaciones, con base en el temario y el calendario que usted proporciona.',
  'aet.review.footer': 'Creado con IA',
  'aet.footerCard.dismiss': 'Descartar',
  'preferenceSetting.sections.isStudyPrepEnabled.descriptionText1': 'La preparación de estudio es una herramienta adicional que apoya el aprendizaje al proporcionarles a los estudiantes videos y problemas de práctica adaptados para este curso.',
  'preferenceSetting.sections.isStudyPrepEnabled.descriptionText2': 'A los estudiantes cuyo plan de acceso no incluya la preparación de estudio se les podría pedir que se suscriban para seguir utilizando los recursos de preparación de estudio.',
  'preferenceSetting.sections.isStudyPrepEnabled.descriptionText3': 'Los estudiantes que ya adquirieron preparación de estudio no se verán afectados por este ajuste.',
  'preferenceSetting.sections.isStudyPrepEnabled.helpLinkText': 'Vea más información sobre los beneficios de la preparación de estudio',
  'aet.home.viewCourseId': 'Ver identificador del curso',
  'aet.home.copy': 'Copiar',
  'aet.home.copied': 'Copiado',
  'aet.home.courseLabel': 'Identificador del curso:',
  'schoolInfoCard.addUniversity': 'Añadir escuela',
  'schoolInfoCard.title': 'Información de la escuela',
  'schoolInfoCard.titleV1': 'Cuéntenos sobre su curso',
  'schoolInfoCard.cta': 'Comenzar',
  'schoolInfoCard.pickInstitution': 'Elegir escuela',
  'schoolInfoCard.addUniversityTitle': 'Añada su escuela',
  'schoolInfoCard.addUniversitySubtitle': 'Conociendo su escuela y curso, permita que le recomendemos los materiales de estudio más útiles.',
  'schoolInfoCard.searchPlaceholder': 'Buscando su escuela...',
  'schoolInfoCard.skip': 'Omitir este paso',
  'schoolInfoCard.nextStep': 'Siguiente paso',
  'schoolInfoCard.notInList': 'Mi escuela no aparece en la lista.',
  'schoolInfoCard.noResults': 'No se encontraron escuelas que coincidan con su búsqueda',
  'schoolInfoCard.noResultsHeading': '¿No encuentra su escuela?',
  'schoolInfoCard.noResultsInstruction': 'Escriba el nombre completo a continuación',
  'schoolInfoCard.noResultsInputPlaceholder': 'Nombre de la escuela',
  'schoolInfoCard.addInstitutionLabel': 'Añadir esta escuela',
  'aet.assignments.assignmentTitlePlaceholder': 'Escriba un título',
  'aet.assignments.titleValidation.titleRequired': 'El título de la asignación es obligatorio.',
  'aet.assignments.titleValidation.titleTooLong': 'El título de la asignación no puede exceder de {0} caracteres.',
  'aet.assignments.titleValidation.titleInvalidChar': 'El título de la asignación contiene caracteres no admitidos.',
  'aet.assignments.titleValidation.titleDuplicate': 'El título de la asignación ya existe',
  'aet.syllabus.timeZoneLabel': 'Huso horario',
  'aet.review.reviewReadingFromAssignments': 'Revisar la lectura de la tarea',
  'aet.assignments.chaptersLabel': 'capítulo(s)',
  'menu.myAccount.subTitle': 'Su institución se aloja aquí',
  'menu.myAccount.subTitleNotAvailable': 'Puede añadir la institución aquí en cualquier momento.',
  'schoolInfoCard.toastMessage': 'Universidad guardada',
  'aet.review.threeDotMenu.askAI': 'Preguntarle a la IA',
  'aet.home.suggestedRemediationSubtitle': 'Vea videos pertinentes y practique para dominar los temas de su curso.',
  'aet.home.laggedQuestionLabel': 'Preguntas marcadas',
  'aet.home.correctAnswer': 'Respuesta correcta',
  'aet.home.incorrectAnswer': 'Respuesta incorrecta más común',
  'aet.home.behaviourTrendsLabel': 'Ideas sobre la pregunta',
  'aet.home.strugglingStudentsLabel': 'Estudiantes con dificultades',
  'aet.home.patternsInStudensAiLabel': 'Patrones en el uso de IA de los estudiantes',
  'aet.home.questionLabel': 'Pregunta',
  'aet.home.studentAskingSimilarQuestions': 'Estudiantes que hicieron preguntas similares:',
  'aet.home.assignmentDifficultQuestions': 'Preguntas difíciles',
  'aet.home.behaviorTrends': 'Ideas sobre la pregunta',
  'aet.home.behaviors': 'Indicadores de desempeño',
  'aet.home.mostDifficultTopics': 'Preguntas más difíciles',
  'aet.home.commentsFromStudentLabel': 'Comentarios de los estudiantes',
  'aet.home.disregard': 'Ignorar',
  'aet.home.reportAsInaccurate': 'Reportar como erróneo',
  'aet.home.Flagged': 'Marcado',
  'aet.home.reportQuestionTitle': 'Reportar pregunta',
  'aet.home.reportQuestionLabel': '¿Qué estaba mal en esta pregunta?',
  'aet.home.showComments': 'Mostrar comentarios',
  'aet.home.studentReports': 'informes del estudiante',
  'aet.home.placeholderText': 'Por favor explique...',
  'aet.home.reportQuestion.notRelevant': 'No es pertinente',
  'aet.home.reportQuestion.notCorrect': 'La información no es correcta',
  'aet.home.reportQuestion.unsafe': 'Inseguro o nocivo',
  'aet.home.reportQuestion.somethingElse': 'Algo más',
  'aet.home.StudentDetails.assistedByAI': 'Con asistencia de IA',
  'aet.home.strugglingStudents.emptyStateTitle': 'Ningún estudiante tiene dificultades ahora',
  'aet.home.strugglingStudents.emptyStateDescription': 'Vuelva a consultar más tarde.',
  'aet.home.overallStatus.excelling': 'Sobresaliente',
  'aet.home.overallStatus.fallingBehind': 'Rezagado',
  'aet.home.overallStatus.keepingUp': 'Al corriente',
  'aet.home.showOnlyDifficultQuestionsLabel': 'Mostrar solo "Preguntas difíciles"',
  'aet.home.showOnlyStrugglingStudentsLabel': 'Mostrar solo "Estudiantes con dificultades"',
  'aet.home.viewQuestionInAssignment': 'Ver pregunta en la asignación',
  'aet.home.insightRisk.incorrectFirstAttempts': 'Primeros intentos incorrectos',
  'aet.home.insightRisk.multipleIncorrectAttempts': 'Varios intentos incorrectos',
  'aet.home.insightRisk.lowConfidence': 'Confianza baja',
  'aet.home.insightRisk.mediumConfidence': 'Confianza media',
  'aet.home.insightRisk.lowEngagement': 'Participación baja',
  'aet.home.insightRisk.countOfStudents': '{count} de {total} estudiantes',
  'aet.home.insightRisk.na': 'N/A',
  'aet.home.strugglingStudentsHereLabel': 'Estudiantes que tienen dificultades aquí',
  'aet.home.insightRisk.didNotAttempt': 'No intentó',
  'aet.home.insightRisk.attempted': 'Attempted',
  'aet.courseHeader.assignableEText': 'Assignable eText',
  'aet.courseHeader.lmsIntegration': 'Integración con LMS',
  'aet.courseHeader.lmsIntegrationSubLabel': 'Connected to your LMS',
  'aet.instructorCourse.courseForm.institutionNotOfferedError': 'This institution does not offer this product.',
  'aet.unlinkCourse.title': 'Unlink Pearson and [LMS] courses?',
  'aet.unlinkCourse.warning.accessInfoBeforePearson': 'Your Pearson course will be unlinked from your [LMS] course. You can still access the Pearson course by signing into ',
  'aet.unlinkCourse.warning.pearsonLinkLabel': 'Pearson',
  'aet.unlinkCourse.warning.accessInfoAfterPearson': ' with your linked account.',
  'aet.unlinkCourse.warning.relinkInfo': 'If no students are enrolled in the Pearson course you’re unlinking, you can link it again with the same [LMS] course.',
  'aet.unlinkCourse.beforeContinueHeading': 'Before you continue:',
  'aet.unlinkCourse.beforeContinueItem': 'If you link your [LMS] course with a different Pearson course, delete all Pearson grades from your [LMS] gradebook and any areas or modules in your LMS course. Otherwise, your [LMS] course may have duplicate grades.',
  'aet.unlinkCourse.inProgressCta': 'Unlinking...',
  'aet.unlinkCourse.okCta': 'OK',
  'aet.unlinkCourse.success.title': 'Unlink successful',
  'aet.unlinkCourse.success.heading': 'Your course has been unlinked from your LMS',
  'aet.unlinkCourse.success.descriptionBeforePearson': 'You can still access the course by signing into ',
  'aet.unlinkCourse.success.descriptionAfterPearson': ' with your Pearson account.',
  'aet.unlinkCourse.failure.title': 'Couldn\'t unlink course',
  'aet.unlinkCourse.failure.paragraph1': 'Your course couldn\'t be unlinked from your LMS. Wait a few minutes and try again.',
  'aet.unlinkCourse.failure.paragraph2': 'If the problem continues, contact Pearson Support.'
};

export default esmx;
